import React from 'react';
import { useParams } from 'react-router-dom';

import styled from 'styled-components';

import { BackToTopButton } from 'components/no-auth/common/back-to-top-button/BackToTopButton';
import { BlogTile } from 'components/no-auth/common/blog-tile/BlogTile';
import { Dropdown } from 'components/no-auth/common/dropdown/Dropdown';
import { PromoPageContainer } from 'components/no-auth/common/promo-page-container/PromoPageContainer';
import { PromoRow } from 'components/no-auth/common/PromoRow/PromoRow';
import { PromoSectionContainer } from 'components/no-auth/common/PromoSectionContainer';
import { HeroSection } from 'components/no-auth/common/sections/HeroSection';
import PaginationSection from 'components/no-auth/common/sections/PaginationSection';
import { SocialMediaSection } from 'components/no-auth/common/sections/SocialMediaSection';
import { TilesSection } from 'components/no-auth/common/sections/TilesSection';
import NewsLayoutV2 from 'components/no-auth/news/NewsLayoutV2';

import { getLangCountryPrefix } from 'helpers/utils';

import promoMedia from 'theme/promoMedia';

const DropdownContainer = styled.div`
    display: flex;
    flex-direction: column;
    padding: 0 32px;
    margin-bottom: 32px;

    ${promoMedia.tablet744} {
        padding: 0 116px;
        margin-bottom: 48px;
    }

    ${promoMedia.desktop1440} {
        flex-direction: row;
        justify-content: center;
        margin-bottom: 64px;
    }
`;
const DropdownWrapper = styled.div`
    margin-bottom: 16px;
    width: 100%;

    &:last-child {
        margin-bottom: 0;
    }

    ${promoMedia.desktop1440} {
        margin-bottom: 0;
        margin-right: 48px;
        max-width: 335px;

        &:last-child {
            margin-right: 0;
        }
    }
`;
const BlogTiles = styled.div`
    margin-left: -10px;
    margin-right: -10px;
`;
const NewsPageV2 = (props) => {
    let { page } = useParams();
    let { category } = useParams();
    let pageParam = page ? page : 1;
    let categoryParam = category ? category : 'all-articles';

    const url = `${getLangCountryPrefix(props.lang, props.country)}/${props.stateOptions?.section}`;
    return (
        <PromoPageContainer bgColor="eggshell03" dataTestId="news-page">
            {props.landing && props.articles && (
                <>
                    {props.landing.hero_block && (
                        <HeroSection
                            title={props.landing.hero_block.title}
                            text={props.landing.hero_block.text}
                            data={props.landing.hero_block}
                            noIconBtn
                            btnVariant="secondary"
                        />
                    )}
                    <PromoSectionContainer>
                        <DropdownContainer>
                            {props.categories && (
                                <DropdownWrapper>
                                    <Dropdown
                                        selectedCategory={categoryParam}
                                        link={`${url}`}
                                        placeholder={props.landing.categoryPlaceholder}
                                        listItems={props.categories}
                                    />
                                </DropdownWrapper>
                            )}
                        </DropdownContainer>
                        <BlogTiles>
                            <PromoRow flex direction="column" indent="adaptive-32-48-64">
                                {Array.isArray(props.articles.data) && (
                                    <>
                                        {props.articles.data
                                            .filter((item) => item !== null)
                                            .map((item) => {
                                                return (
                                                    <BlogTile
                                                        key={item.id}
                                                        date={item.date}
                                                        title={item.title}
                                                        text={item.preview_text}
                                                        img={item.img}
                                                        link={`${url}/${item.slug}`}
                                                        categories={item.categories}
                                                        isNewsPage={props.stateOptions.section !== 'blog'}
                                                    />
                                                );
                                            })}
                                    </>
                                )}
                            </PromoRow>
                        </BlogTiles>
                        {typeof props.articles.pagesAmount == 'number' && props.articles.pagesAmount > 1 && (
                            <PaginationSection
                                href={`${url}/category/${categoryParam}`}
                                pagesCount={props.articles.pagesAmount}
                                visiblePagesCount={5}
                                currentPage={Number(pageParam)}
                            />
                        )}
                        {props.social_section.title && props.social_section.icons && (
                            <SocialMediaSection socialTitle={props.social_section.title} socialIcons={props.social_section.icons} />
                        )}
                        {props.landing.tiles_section && <TilesSection lang={props.lang} country={props.country} data={props.landing.tiles_section} />}
                        {props.landing.backToTopBtn && <BackToTopButton caption={props.landing.backToTopBtn} />}
                    </PromoSectionContainer>
                </>
            )}
        </PromoPageContainer>
    );
};

export default NewsLayoutV2(NewsPageV2);
